import React from "react";
import PropTypes from "prop-types";
import Avatar from "react-avatar";

import InputField from "components/Input";
import Button from "components/Button";
import "./index.scss";

const CompleteModal = ({
  userDetails = {},
  handleInputChange = () => {},
  formValues,
  handleSubmit = () => {},
  isSubmitting,
  user,
}) => {
  return (
    <>
      <div className="compelete-profile">
        <p className="title">PERSONAL</p>
        <div className="details">
          <div>
            <InputField
              label="First Name"
              name="firstName"
              placeholder=""
              onChange={(e) => handleInputChange(e)}
              value={formValues?.firstName}
            />
            <InputField
              label="Last Name"
              name="lastName"
              placeholder=""
              onChange={(e) => handleInputChange(e)}
              value={formValues?.lastName}
            />
          </div>
          <div className="avatar">
            <Avatar
              name={userDetails?.first_name || user?.email}
              size="70"
              imgSrc={user?.picture || ""}
              round
            />
          </div>
        </div>
        <div className="input-field">
          <label htmlFor="userType" className="label">
            User Type
          </label>
          <select
            name="userType"
            className="select-input"
            onChange={(e) => handleInputChange(e)}
            value={formValues?.userType}
          >
            <option value="">--</option>
            <option value="farmer">Farmer</option>
            <option value="agronomist">Agronomist</option>
            <option value="researcher">Researcher</option>
            <option value="input Supplier">Input Supplier</option>
            <option value="education">Education</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div className="action">
          <Button
            color="green"
            type="solid"
            onClick={(e) => handleSubmit(e)}
            label="Update Profile"
            disabled={isSubmitting}
            loading={isSubmitting}
          />
        </div>
      </div>
    </>
  );
};
CompleteModal.propTypes = {
  userDetails: PropTypes.node.isRequired,
  formValues: PropTypes.node.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  user: PropTypes.node.isRequired,
};
export default CompleteModal;
